import { Home } from "lucide-react";
import { ProviderMap } from "@/components/business/BizMap";
import { useAuth } from "@/context/AuthContext";
import { useHousehold } from "@/context/HouseholdContext";

export const HouseholdMapPanel = () => {
  const { active } = useHousehold();
  const { user } = useAuth();
  if (!active) return null;
  const canEdit = !user?.read_only && ["owner", "admin", "adult"].includes(active.role);
  return (
    <ProviderMap base={`/households/${active.id}`} canEdit={canEdit}
      center={{ name: active.name, logo: <Home className="h-7 w-7 text-[#8ce2b8] sm:h-10 sm:w-10" /> }}
      emptyText="Ajoutez les fournisseurs du foyer (électricité, box internet, mobile, assurances…) ou reprenez ceux détectés ci-dessous." />
  );
};
